import React from "react";
import { useHistory } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { ComingSoonBand, PlatformCard, PlatformCards } from "../../../components/landing/LaunchSections";
import { MOVE_LAUNCH } from "./MoveHero";

const PILLARS: PlatformCard[] = [
  { label: "MOVE", color: "#017bef", title: "Car Rental", description: "Get where you need to go." },
  { label: "WORK", color: "#0062c0", title: "Workspace", description: "Get things done." },
  { label: "STAY", color: "#0ea5e9", title: "Accommodation", description: "Rest and recharge." },
  { label: "PLAY", color: "#6366f1", title: "Experience", description: "Make the most of it." },
];

export function MoveOnePlatform() {
  return (
    <PlatformCards
      eyebrow="One Platform"
      title="One Journey. One Platform."
      cards={PILLARS}
      footnote="SPACIA brings flexible workspaces, quality accommodation and curated experiences together so you can spend less time searching and more time doing what matters."
    />
  );
}

const PARTNER_POINTS = [
  { title: "Reach", description: "Access users already booking Work, Stay and Play." },
  { title: "Visibility", description: "Make your rental fleet discoverable within SPACIA." },
  { title: "Connected Journey", description: "Become part of a user's wider travel experience." },
];

export function MovePartner() {
  const history = useHistory();

  return (
    <section className="bg-white py-20">
      <div className="mx-auto grid max-w-[1440px] grid-cols-1 items-center gap-16 px-[16px] sm:px-8 lg:grid-cols-2">
        <img
          src="/figma-assets/move/partner.jpg"
          alt="Rental fleet parked in a row"
          className="h-[360px] w-full rounded-3xl object-cover sm:h-[492px]"
        />
        <div>
          <p className="text-[14px] font-semibold uppercase leading-5 tracking-[1.4px] text-[#017bef]">For Partners</p>
          <h2 className="pt-[12px] text-[36px] font-bold leading-[1.2] tracking-[-1.2px] text-[#0a0a0a] sm:text-[48px] sm:leading-[48px]">
            Have a Fleet to Share?
          </h2>
          <p className="pt-[20px] text-[18px] leading-[29.25px] text-[#717182]">
            Accredited car rental companies can list their fleet on SPACIA, reaching users who are already booking their
            workspaces, stays and experiences on the platform.
          </p>
          <ul className="space-y-[16px] pt-8">
            {PARTNER_POINTS.map(point => (
              <li key={point.title} className="flex items-start gap-[12px] text-[14px] leading-5">
                <span className="mt-0.5 flex size-4 shrink-0 items-center justify-center rounded-full bg-[#017bef]/10">
                  <Check className="size-2.5 text-[#017bef]" />
                </span>
                <span>
                  <span className="font-semibold text-[#0a0a0a]">{point.title} — </span>
                  <span className="text-[#717182]">{point.description}</span>
                </span>
              </li>
            ))}
          </ul>
          <button
            type="button"
            onClick={() => history.push("/partner-signup")}
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#017bef] px-7 py-3.5 text-[14px] font-bold leading-5 text-white drop-shadow-[0_2px_8px_rgba(1,123,239,0.2)] transition-colors hover:bg-[#0062c0]"
          >
            List Your Fleet
            <ArrowRight className="size-[15px]" />
          </button>
        </div>
      </div>
    </section>
  );
}

export function MoveComingSoon() {
  const history = useHistory();

  return (
    <ComingSoonBand
      title="Move Is Coming to SPACIA"
      description="Car rental is coming to SPACIA, connecting you with accredited providers and giving you more freedom to move between every part of your journey."
      launch={MOVE_LAUNCH}
      primaryCta={{ label: "Get Started", onClick: () => history.push("/package-signup") }}
      secondaryCta={{ label: "List Your Fleet", onClick: () => history.push("/partner-signup") }}
    />
  );
}
